import React from "react"
// @ts-ignore
import PillUser from "../../../../../gd-components/molecules/pill/pill-user";
// @ts-ignore
import Pill from "../../../../../gd-components/molecules/pill/pill";

export default function FieldUser_MultiselectValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, (option, key) => {

                    if (!option.value) {
                        return (
                            <Pill     label         = {option.label}
                                      size          = "26"
                                      value         = {option}
                                      onClick       = {props.onClick}
                                      onDelete      = {props.onDelete}
                                      className     = 'm-t-4 m-b-4 m-r-4'
                                      key           = {key}
                            />
                        )
                    }

                    return <PillUser userId        = {option.value}
                                     size          = {26}
                                     value         = {option}
                                     onClick       = {props.onClick}
                                     onDelete      = {props.onDelete}
                                     className     = 'm-t-4 m-b-4 m-r-4'
                                     key           = {option.value}
                    />



                })}
            </div>
            {props.children}
        </React.Fragment>
    );
}
